import { lazy } from 'react';
import { Container, Stack } from '@mui/material';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { Loader } from '@client/components/common/Loader';
import { Shows } from './Shows';
import { Hosts } from './Hosts';
import { CTA } from './CTA';
import { Stats } from './common/Stats';
import { Article } from './Article';
import { TicketingBlock } from './TicketingBlock';
import { Testimonials } from './Testimonials';

const HeaderLoader = lazy(() => import(/* webpackPrefetch: true */ './common/Header'));

export const Home = () => {
  const isMobile = useIsMobile();

  return (
    <Container
      maxWidth="lg"
      disableGutters
    >
      {!isMobile && <Loader load={HeaderLoader} />}

      <Stack
        spacing={isMobile ? 4 : 10}
        alignItems="center"
      >
        <CTA />

        <Testimonials />

        <Shows />

        <Hosts />

        <Stats />

        <TicketingBlock />

        <Article />
      </Stack>
    </Container>
  );
};

export default Home;
